<template>
    <div
        class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
        id="page-login"
    >
        <div class="filter"></div>

        <vs-col class="sm:w-3/4 md:w-3/4 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
            <vx-card>
                <div slot="no-body" class="full-page-bg-color">
                    <div class="flex justify-center items-center">
                        <div class="sm:hidden lg:block lg:w-1/2">
                            <maarima-logo tagline="stack" :theme="logoColor" class="logo" />
                        </div>

                        <div
                            style="width: 100%"
                            class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg"
                        >
                            <div class="p-8 login-tabs-container">
                                <vs-tabs v-model="step">
                                    <vs-tab>
                                        <sign-in
                                            :redirect="redirectto"
                                            :email.sync="email"
                                            @forgot="openForgot"
                                            @register="openRegistration"
                                        ></sign-in>
                                    </vs-tab>
                                    <vs-tab>
                                        <forgot-password
                                            :email.sync="email"
                                            @cancel="openSignIn"
                                        ></forgot-password>
                                    </vs-tab>
                                    <vs-tab>
                                        <register
                                            :email.sync="email"
                                            @cancel="openSignIn"
                                        ></register>
                                    </vs-tab>
                                    <vs-tab>
                                        <verify-email
                                            :email.sync="email"
                                            @cancel="openSignIn"
                                        ></verify-email>
                                    </vs-tab>
                                    <vs-tab>
                                        <activate
                                            :email.sync="email"
                                            @cancel="openSignIn"
                                        ></activate>
                                    </vs-tab>
                                    <vs-tab>
                                        <reset-password
                                            :email.sync="email"
                                            @cancel="openSignIn"
                                        ></reset-password>
                                    </vs-tab>
                                </vs-tabs>
                            </div>
                        </div>
                    </div>
                </div>
            </vx-card>
        </vs-col>
    </div>
</template>

<script>
import SignIn from './views/SignIn'
import ForgotPassword from './views/ForgotPassword'
import Register from './views/Register'
import VerifyEmail from './views/VerifyEmail'
import Activate from './views/Activate'
import ResetPassword from './views/ResetPassword'
import { mapQueries, mapParams } from '../../plugins/mappers'
import { mapGetters } from 'vuex'

export default {
    name: 'login',
    components: {
        SignIn,
        ForgotPassword,
        Register,
        VerifyEmail,
        Activate,
        ResetPassword
    },
    data() {
        return {
            email: '',
            stepMap: {
                login: 0,
                forgot: 1,
                register: 2,
                verify: 3,
                activate: 4,
                reset: 5
            },
            redirecting: false
        }
    },
    computed: {
        ...mapParams('action'),
        ...mapQueries('redirectto'),
        ...mapGetters({
            themeMode: 'user/themeMode'
        }),
        logoColor() {
            if (this.themeMode == 'dark') {
                return 'dark'
            }
            return 'default'
        },
        actions() {
            return Object.keys(this.stepMap)
        },
        reverseStepMap() {
            var ret = {}
            Object.keys(this.stepMap).forEach((key) => {
                ret[this.stepMap[key]] = key
            })
            return ret
        },
        step: {
            get() {
                return this.stepMap[this.action]
            },
            set(value) {
                if (this.step != value && !this.redirecting) {
                    var action = this.reverseStepMap[value]
                    if (this.$route.params.action != action) {
                        this.action = action
                    }
                }
            }
        }
    },
    methods: {
        openForgot() {
            this.step = 1
        },
        openRegistration() {
            this.step = 2
        },
        openSignIn() {
            this.step = 0
        },
        check_redirect() {
            if (!this.actions.includes(this.action)) {
                this.redirecting = true
                this.$router.replace({ name: '404' })
            }
        }
    }
}
</script>

<style scoped>
.vs-tabs >>> .con-ul-tabs {
    display: none !important;
}
.clickable {
    cursor: pointer;
}
.filter {
    background-color: #293336;
    opacity: 0.8;
    left: 0;
    width: 100%;
    height: 100%;
    top: 0;
    position: absolute;
}

.logo {
    margin: auto;
    max-width: 75%;
    max-height: 50%;
    height: 80%;
}
</style>
